import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Box,
} from '@mui/material'
import {
  Close as CloseIcon,
  WarningAmber as WarningIcon,
} from '@mui/icons-material'

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
  type = 'delete', // 'delete', 'warning', 'info'
  itemType = 'item',
  onCancel,
  showCancelButton = false
}) => {
  const getTypeConfig = () => {
    switch (type) {
      case 'delete':
        return {
          icon: (
            <WarningIcon
              sx={{ width: '24px', height: '24px', color: 'var(--forbrand-error)' }}
            />
          ),
          titleColor: 'var(--forbrand-error)',
          buttonColor: 'var(--forbrand-error)',
        }
      case 'warning':
        return {
          icon: <WarningIcon sx={{ fontSize: 24, color: '#ff9800' }} />,
          titleColor: '#ff9800',
          buttonColor: '#ff9800',
          buttonHoverColor: '#f57c00',
        }
      default:
        return {
          // icon: <WarningIcon sx={{ fontSize: 24, color: 'var(--forbrand-error)' }} />,
          titleColor: 'var(--forbrand-primary)',
          buttonColor: 'var(--forbrand-error)',
          buttonHoverColor: 'var(--forbrand-error)',
        }
    }
  }

  const typeConfig = getTypeConfig()

  const defaultTitle = `Are you sure you want to delete this ${itemType}?`
  const defaultMessage = `This action can't be undone. The ${itemType} will permanently lose access, and all associated data may be removed.`

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        if (onClose) onClose();
      }}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '12px',
          maxWidth: '480px',
        },
      }}
    >
      {/* Dialog Content */}
      <DialogContent
        sx={{
          padding: '24px 24px 0px 24px',
          textAlign: 'left',
        }}
      >
        {/* Warning Icon and Title */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: '16px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
            }}
          >
            {typeConfig.icon}
            <Typography
              variant="h6"
              sx={{
                color: typeConfig.titleColor,
                fontWeight: 500,
                fontSize: '16px',
                margin: 0,
              }}
            >
              {title || defaultTitle}
            </Typography>
          </Box>
          {
            onClose && (
              <Box>
                <IconButton onClick={onClose}>
                  <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
            )
          }
        </Box>

        {/* Message */}
        <Typography
          sx={{
            color: 'var(--forbrand-secondary)',
            fontSize: '14px',
          }}
        >
          {message || defaultMessage}
        </Typography>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions
        sx={{
          padding: '32px 32px 24px 0px',
          justifyContent: 'flex-end',
          gap: '12px',
        }}
      >
        {showCancelButton && <Button
          // variant="outlined"
          onClick={onCancel}
          sx={{ px: '8px 16px', borderColor: 'gray', color: 'var(--forbrand-primary)', textTransform: 'none' }}
        >
          Cancel
        </Button>}
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: 'var( --forbrand-error)',
            color: '#ffffff',
            borderRadius: '6px',
            padding: '8px 16px',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            boxShadow: 'none',

          }}
        >
          {confirmText}{' '}
          {itemType === 'user'
            ? 'User'
            : itemType === 'entity'
              ? 'Entity'
              : itemType === 'tan'
                ? 'TAN'
                : ''}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
